import { Permission } from 'core/api';
import { Command } from 'pos/common';
import { showDocumentPayments } from 'pos/modules/helpers/payments-processing';
import * as SalesStore from '../SalesStore';

declare global {
	interface CommandType {
		showTicketPayments: () => Promise<Result>
	}
}

Command.register('showTicketPayments', 'NO_PRECONDITION', async () => {

	return showDocumentPayments({
		addPaymentPermission: Permission.Ticket_AddPayment,
		removePaymentPermission: Permission.Ticket_RefundPayment,
		getTicket: async () => SalesStore.getTicket(),
		updatePayments: (payments, prepayAmount) => SalesStore.addPayments(payments, prepayAmount),
		documentType: 'Ticket',
		printDocument: async () => {
			await SalesStore.printTicket('IGNORE_TICKET_PRINTED_FLOW');
		}
	});
});